import { render, staticRenderFns } from "./LimitTags.vue?vue&type=template&id=2231e3e1"
import script from "./LimitTags.vue?vue&type=script&lang=js"
export * from "./LimitTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports